import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from 'react';

import moment from 'moment';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { adaptTipoProfesionalArray } from '../../../adapters/tipoProfesionalAdapter';
import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_ALL_TIPO_PROFESIONALES } from '../../../data/graphQL/queries/PlanCuidado/getTipoProfesionales';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { normalizeFilterValue } from "../../../helpers/tools";
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { getLastYearsList } from '../../../utils/helpers';
import { mesesEnum } from "../../MisVisitas/constants";
import { fieldsToSearch } from '../constants/fieldsToSearch';

export const useGetFilters = () => {
  const estadosOptions = [
    { value: 1, id: 1, label: 'Cumplidas', displayName: 'Cumplidas' },
    { value: 2, id: 2, label: 'Incumplidas', displayName: 'Incumplidas' },
    { value: -1, id: -1, label: 'Todos', displayName: 'Todos' }];

  const aniosOptions = getLastYearsList(8).map((year) => ({ id: year, displayName: year.toString() }));
  const [tipoProfesionales, setTipoProfesionales] = useState([]);
  const [delegaciones, setDelegaciones] = useState([]);
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);

  const storageId = sessionStorage.getItem('idUsuario');

  const { filters, handleChangeFilters } = usePersistFilters({
    idDelegacion: delegacionOrigen,
    idTipoProfesional: 1, // Tipo Profesional por defecto 1 (Médico)
    mes: mesesEnum.find((m) => m.value === parseInt(moment().format('MM'))).code,
    anio: parseInt(moment().format('YYYY')),
    txtFiltro: '',
    estado: -1 // Estado por defecto -1, opciones posibles: Cumplidas (1), Incumplidas (2), Todas (-1)  
  }, "controlVisitasFilters");

  const [getDelegaciones, { data: dataDelegaciones, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegaciones) return;
    setDelegaciones(adaptDelegacionArray(dataDelegaciones));
  }, [dataDelegaciones]);

  const [getDelegacionOrigen, { data: dataDelegacionOrigen, loading: delegacionOrigenLoading }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegacionOrigen) return;
    if (dataDelegacionOrigen.usuarioFull.success) {
      const deleg = parseInt(dataDelegacionOrigen.usuarioFull.valorEsperado.delegacionOrigen, 10);
      sessionStorage.setItem('delegacionOrigen', deleg);
      setDelegacionOrigen(deleg);

      if (filters.idDelegacion == 0)
        handleChangeFilters('idDelegacion', deleg);
    }
  }, [dataDelegacionOrigen]);

  const [getTipoProfesionales, { data: dataTipoProfesionales, loading: tipoProfesionalesLoading }] = useLazyQuery(GET_ALL_TIPO_PROFESIONALES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataTipoProfesionales) return;
    setTipoProfesionales(adaptTipoProfesionalArray(dataTipoProfesionales));
  }, [dataTipoProfesionales]);


  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId, 10) } });
    }
    getDelegacionOrigen({ variables: { idUsuario: JSON.parse(storageId, 10) } });
    getTipoProfesionales();
  }, []);

  const applyTextFilter = (data, textFilter) => {
    const inputBuscar = textFilter?.trim().toUpperCase();

    if (inputBuscar === "" || inputBuscar?.length < 3) return data;

    const dataFiltered = data?.filter((row) => {
      return fieldsToSearch.some((fieldName) => {
        // if (fieldName === 'profesionalASignado' && activeTabEnum === 'ASIGNACION' && estado !== -2) return false;

        const value = normalizeFilterValue(row[fieldName]);
        return value.includes(inputBuscar);
      });
    });

    return dataFiltered;
  };

  const applyClientSideFilters = (data, textFilter) => {
    const dataFilteredByText = applyTextFilter(data, textFilter);

    return dataFilteredByText;
  };

  return {
    paramsLoading: delegacionOrigenLoading || delegacionesLoading || tipoProfesionalesLoading,
    delegaciones,
    delegacionOrigen,
    tipoProfesionales,
    estadosOptions,
    aniosOptions,
    mesesEnum,
    filters,
    handleChangeFilters,
    applyClientSideFilters
  };
};